export const steps = [
  { label: 'Test Details' },
  { label: 'Environments' },
  { label: 'Test Frequency' },
  { label: 'Step Details' },
  { label: 'Test Conditions' },
  { label: 'Alert Conditions' }
];
